module.exports = __webpack_public_path__ + "static/media/gif-6.74988e76.gif";